<template>
<div class="goods-shaer-poster">
    <el-dialog title="配件海报" :visible.sync="shareVis" center  :destroy-on-close="true" :width="800+'px'" top="30px" custom-class="poster-dia">
        <div class="pos-main">
          <el-form :model="posterInfo" label-width="80px" size="mini" v-if="posNum==1">
            <el-form-item label="放假日期" v-if="goodsInfo.group_title&&(goodsInfo.group_title.includes('放假') || goodsInfo.group_title.includes('假日'))">
              <el-input v-model="posterInfo.content" placeholder="请输入放假日期"></el-input>
            </el-form-item>
            
            <!-- 公司名称 -->
            <el-form-item label="公司名称">
              <el-input v-model="posterInfo.name" placeholder="此处请填写公司名称"></el-input>
            </el-form-item>

            <!-- 共同体单位选项 -->
            <el-form-item label="如需添加特殊标识,请勾选" label-width="180px">
              <el-checkbox v-model="posterInfo.isUnionMember">华诺威共同体单位</el-checkbox>
            </el-form-item>

            <!-- 电话 -->
            <el-form-item label="电话">
              <el-input v-model="posterInfo.phone"></el-input>
            </el-form-item>

            <!-- 地址 -->
            <el-form-item label="地址">
              <el-input v-model="posterInfo.address"></el-input>
            </el-form-item>

            <!-- 背景图选择 -->
            <el-form-item label="背景模板">
              <div class="image-list">
                <el-image
                  :style="{width:160+'px'}"
                  :src="posterInfo.bodyImg"
                  :preview-src-list="[posterInfo.bodyImg]"    
                ></el-image>
              </div>
            </el-form-item>
            
          </el-form>

          <div id="poster-body" v-else-if="posNum==2" >
            
            <img :src="posBackbodyImg" alt="" srcset="">
            <div class="pos-texts" :style="{'background-color':posBackColor}">
              <div class="companyName">{{ posterInfo.name}}</div>
              <div v-if="posterInfo.content" class="companyName time-content">放假日期:{{ posterInfo.content}}</div>
              <div class="phone">电话: {{posterInfo.phone}}</div>
              <div class="address">地址: {{posterInfo.address}}</div>
            </div>
          </div>

        </div>
        <div slot="footer" class="dialog-footer">
     
          
          <el-button size="mini" type="primary" @click="producePoster">{{ posNum==2?'保存图片':'生成海报' }}</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
 import html2canvas from 'html2canvas';
export default {
    data(){
        return{
            shareVis: false, //分享海报
            posNum:1,
            posterWidth:800,
            posterInfo:{
              imgList:[],
              bodyImg:"",
              name:this.$store.state.store_name,
              phone:"",
              address:"",
              isUnionMember: true // 默认选中华诺威共同体单位
            }
        }
    },
    mounted() {
      // 获取屏幕可用高度（减去一些边距）
        const screenHeight = window.innerHeight - 140;
        // 目标宽高比为740:1200
        const targetRatio = 740 / 1200;
        
        // 根据屏幕高度计算合适的海报高度
        let posterHeight = Math.min(screenHeight, 1200);
        // 根据宽高比计算对应的宽度
        let posterWidth = posterHeight * targetRatio;
        
        // 确保宽度不超过对话框最大宽度
        const maxWidth = 740; // 最大宽度，可根据需要调整
        if (posterWidth > maxWidth) {
          posterWidth = maxWidth;
          posterHeight = posterWidth / targetRatio;
        }
        this.posterWidth = posterWidth
    },
    beforeDestroy() {
    
    },
    methods:{
      // 处理窗口大小变化
      handleResize() {
        // 强制重新渲染计算属性
        this.$forceUpdate();
      },
      // 分享
        async sharePoster() {
          if(!this.goodsInfo.group_title.includes('放假') && !this.goodsInfo.group_title.includes('假日')){
            this.posterInfo.content = ""
          }
          if(this.goodsInfo.goodsPosImg){

            let replaStrat = window.location.hostname.startsWith('www.')?'https://www.':"https://";
            this.posterInfo.imgList = this.goodsInfo.goodsPosImg.map(item=>{
                return {
                    image:item.image.replace('https://image.oos.huanuowei.cn', replaStrat+`huanuowei.cn/agent-image`),
                    g_production:item.g_production
                }
            })
            this.posterInfo.bodyImg = this.posterInfo.imgList[0].image
          }
          
          if(this.goodsInfo.sccode){
            this.posterInfo.goods_name = this.goodsInfo.goods_name + this.goodsInfo.sccode
          }else{
            this.posterInfo.goods_name = this.goodsInfo.title
          }
          
          this.$nextTick(()=>{
              this.shareVis = true
          })
          
        },
        async exportToPNG() {
          
          const element = document.getElementById('poster-body');
          // 使用 html2canvas 截图
          const canvas = await html2canvas(element, {
            backgroundColor: null, // 保留透明背景
            useCORS: true, // 如果有跨域图片资源，启用该选项
            scale: window.devicePixelRatio * 2, // 提高缩放比例，使用设备像素比的2倍
            dpi: 300, // 设置高DPI
            logging: false // 关闭日志
          });

          // 将 canvas 转换为 base64 图片
          const base64Image = canvas.toDataURL('image/png');
          
          const response = await fetch(base64Image);
          const blob = await response.blob();

          // 创建 ClipboardItem

          const clipboardItem = new ClipboardItem({ [blob.type]: blob });

          // 写入剪贴板
          await navigator.clipboard.write([clipboardItem]);

          this.$suMsg("已复制到剪切板")
          // 设置到页面上显示
          this.imageSrc = base64Image;
          // 可选：自动下载图片
          
          this.downloadImage(base64Image, this.posterInfo.goods_name+'.png');
          // this.shareVis = false
        },
        downloadImage(dataUrl, filename) {
          const a = document.createElement('a');
          a.href = dataUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        async fdownloadImage(url, filename = 'test.jpg') {
          try {
            // 1. 获取图片数据
            const response = await fetch(url);
            if (!response.ok) throw new Error('图片获取失败');

            const blob = await response.blob();

            // 2. 创建临时下载链接
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = filename; // 指定下载的文件名

            // 3. 触发下载
            document.body.appendChild(a);
            a.click();

            // 4. 清理
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);
          } catch (error) {
            console.error('下载失败:', error);
          }
        },
        // 预览
        async producePoster(){
          console.log("posterInfo",this.posterInfo);
          
          if(this.posNum==2){
            this.exportToPNG()
          }else{
            
           
            if(!this.posterInfo.name||!this.posterInfo.phone ||!this.posterInfo.address){
              return this.warMsg("请填写完整信息")
            }
            
            // 根据isUnionMember选择状态决定是否在name后面拼接文字
            // 确保即使用户手动输入了"-华诺威共同体单位"，也不会重复添加
            let submitName = this.posterInfo.name;
            if (this.posterInfo.isUnionMember && !this.posterInfo.name.includes('-华诺威共同体单位')) {
              submitName = this.posterInfo.name + '-华诺威共同体单位';
            }
            
            this.$api.createPoster({
                ...this.goodsInfo,
                ...this.posterInfo,
                name: submitName, // 使用可能拼接后的名称
                member_id: this.$store.state.member_id,
                member_name: this.$store.state.member_name,
                store_id: this.$store.state.store_id,
                store_name: this.$store.state.store_name
            })
            
            this.$suMsg("已提交")
            this.shareVis = false
          }
        },
    },
  
    created() {

    },
    watch: {
      "posterInfo.bodyImg":(n,o)=> {
      }
    },
    props:{
      posBackColor:"",
      posBackbodyImg:"",
      goodsInfo: {
          type: Object,
          default: function() {
              return {};
          }
      }
    }
}
</script>

<style lang="scss">
.goods-shaer-poster{
   .el-dialog__body{
    padding: 4px 0;
   }
    .poster-dia{
      .image-list{
        .el-radio-group{
          display: flex;
          align-items: center;
        }
      }
      .pos-main{
        padding: 10px;
        padding-top: 0;
        position: relative;
        #poster-body{
          position: relative;
          overflow: hidden;
          text-align: center;
          background: #fff;
          display: flex;
          flex-direction: column;
          img{
            pointer-events: none;
            width: 100%;
            height: auto;
            flex: 1;
          }
          .pos-texts{
            width: 100%;
            padding: 14px;
            padding-left: 25px;
            box-sizing: border-box;
            color: #fff;
            text-align: left;
            >div{
              font-size: clamp(12px, 2vw, 18px);
            }
            
            .companyName{
              font-size: clamp(18px, 3vw, 28px);
              font-weight: 700;
            }
            .time-content{
              margin-top: 10px;
            }
            .phone{
              margin: 10px 0;
            }
          }
        }
      }
      .el-dialog__footer{
        padding-top: 0;
        padding-bottom: 10px;
        text-align: center;
      }
    }
}
</style>